class PopUp extends HTMLElement {
  constructor() {
    super();

    this.popupWrapper = this.querySelector('[data-popup-wrapper]');
    this.popupTriggers = this.querySelectorAll('[data-popup-trigger]');
    this.popupShadow = this.querySelector('[data-popup-shadow]');

    this.popupTriggers.forEach((item) => {
      item.addEventListener('click', () => {
        this.open();
      });
    });

    window.addEventListener('resize', () => {
      this.close();
    });
  }

  open() {
    this.classList.toggle('popup-is-open');
    document.body.classList.toggle('popup-is-open');
  }

  close() {
    this.classList.remove('popup-is-open');
    document.body.classList.remove('popup-is-open');
  }
}

if (!customElements.get('pop-up')) {
  customElements.define('pop-up', PopUp);
}
